import axios from "utils/axios";
import * as types from "./ActionTypes";
import { API_URL } from "configs";

const loader = (label) => ({
  type: "SHOW_LOADER",
  common_loader_label: label,
});

const hideLoader = () => ({
  type: "HIDE_LOADER",
});

const snackbar = (msg, type = "general_error") => ({
  type: "SHOW_SNACKBAR",
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch) => {
  const res = error?.response;
  if (res?.status === 422) {
    dispatch({
      type: types.SETUP_CONFIG_VALIDATION_ERROR,
      validation_error: res.data?.errors || res.data?.error || {},
    });
    return;
  }

  dispatch(
    snackbar(
      res?.data?.error ||
        res?.data?.message ||
        `${res?.status || ""} ${res?.statusText || "Request failed"}`.trim()
    )
  );
};

const authHeaders = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const hideSetupConfigValidationError = (fieldKey) => ({
  type: types.HIDE_SETUP_CONFIG_FIELD_VALIDATION_ERROR,
  field_key: fieldKey,
});

export const fetchSetupConfigurations =
  (category, params = {}) =>
  (dispatch) => {
    return axios
      .get(`${API_URL}app-settings`, {
        params: { category, ...params },
        headers: authHeaders(),
      })
      .then((res) => {
        const envelope = res?.data || {};
        const items = envelope?.data?.items ?? envelope?.items ?? envelope?.data ?? [];

        dispatch({
          type: types.SETUP_CONFIG_FETCH_SUCCESS,
          category,
          items: Array.isArray(items) ? items : [],
        });
      })
      .catch((err) => {
        handleError(err, dispatch);
        dispatch({
          type: types.SETUP_CONFIG_FETCH_SUCCESS,
          category,
          items: [],
        });
      });
  };

export const saveSetupConfigurations =
  (category, items, objectViewedId = "") =>
  (dispatch) => {
    dispatch({ type: types.SETUP_CONFIG_REQUEST, category });
    dispatch(loader("Saving configuration..."));

    return axios
      .put(
        `${API_URL}app-settings/bulk`,
        {
          category,
          items,
          object_viewed_id: objectViewedId,
        },
        { headers: authHeaders() }
      )
      .then((res) => {
        dispatch(hideLoader());
        const message =
          res?.data?.message || "Configuration saved successfully";
        dispatch(snackbar(message, "success"));
        dispatch({
          type: types.SETUP_CONFIG_SAVE_SUCCESS,
          category,
          items,
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        handleError(err, dispatch);
      });
  };
